module.exports = __webpack_public_path__ + "static/media/Rectangle 109.b5e6d843.png";